import { WatcherFunction } from '..'
import { watchFetchRequest } from './fetch'
import { watchFetchStatesRequest } from './states'

export const rootResourceSagas: ReadonlyArray<WatcherFunction> = [
  watchFetchRequest,
  watchFetchStatesRequest,
]
